import { API_PATHS } from "../constants/api-paths";
import { qrConstants } from "../constants/util";
import { getSessionData } from "@repo/shared-utils/common-utils";
import { encryptedRequest } from "../core/api.client";

export type IQrRewardsRequest = {
  mobileNo: string;
  eventId: string;
  childEventId: string;
  campaign?: { Id: string; rewardedFlg: boolean };
  lob: string;
  transaction: {
    dateTime: string;
    totalAmount: number;
    refNumber: string;
    isRedeem: boolean;
    status: string;
    payments: string | null;
    customer: {
      CustomerId: string;
      Mobile: string;
    };
  };
  channelCode: string;
};

export const qrRewardsApiCall = async (oemName?: string) => {
  const sessionData = await getSessionData();
  const getFormattedDateTime = () => {
    const now = new Date();
    const day = String(now.getDate()).padStart(2, "0");
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const year = now.getFullYear();
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const seconds = String(now.getSeconds()).padStart(2, "0");
    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  };

  const generateRefNumber = () => {
    return Math.random().toString().slice(2, 18).padEnd(16, "0");
  };

  const currentUrl = globalThis.window.location.href;
  let LOB: string;
  if (currentUrl.includes("qr-code-web-page")) {
    LOB = qrConstants.lob;
  } else if (currentUrl.includes("qr-code-rural-web-page")) {
    LOB = qrConstants.lob_rural;
  } else {
    LOB = qrConstants.lob_lsf;
  }
  const data = {
    mobileNo: sessionData.mobileNo,
    eventId: qrConstants.eventId,
    childEventId: qrConstants.childEventId,
    campaign: oemName ? { Id: oemName, rewardedFlg: true } : {},
    lob: LOB,
    transaction: {
      dateTime: getFormattedDateTime(),
      refNumber: generateRefNumber(),
      status: qrConstants.transactionStatus,
      payments: null,
      customer: {
        CustomerId: sessionData.custId,
        Mobile: sessionData.mobileNo,
      },
    },
    channelCode: qrConstants.channelCode,
  } as IQrRewardsRequest;

  const response = await encryptedRequest({
    method: "POST",
    url: API_PATHS.qrRewards,
    data: data,
  });
  return response;
};
